import React from "react";
import $ from "jquery";

window.jQuery = $;
window.$ = $;
global.jQuery = $;

const MarcaPage = React.lazy(() =>
  import("./App/views/cadastros/Marca/MarcaView"),
);
const EquipamentoPage = React.lazy(() =>
  import("./App/views/cadastros/Equipamento/EquipamentoView"),
);
const CategoriaPage = React.lazy(() =>
  import("./App/views/cadastros/Categoria/CategoriaView"),
);
const UnidadeMedidaPage = React.lazy(() =>
  import("./App/views/cadastros/UnidadeMedida/UnidadeMedidaView"),
);
const UsuarioPage = React.lazy(() =>
  import("./App/views/cadastros/Usuario/UsuarioView"),
);
const EmpresaPage = React.lazy(() =>
  import("./App/views/cadastros/Empresa/EmpresaView"),
);
const ProdutoPage = React.lazy(() =>
  import("./App/views/cadastros/Produto/ProdutoView"),
);
const ProdutoFormPage = React.lazy(() =>
  import("./App/views/cadastros/Produto/ProdutoForm"),
);
const TabelaPreco = React.lazy(() =>
  import("./App/views/cadastros/TabelaPreco/TabelaPrecoView"),
);
const TributacaoPorNcmPage = React.lazy(() =>
  import("./App/views/cadastros/TributacaoPorNCM/TributacaoPorNCMView"),
);
const TributacaoPorNcmFormPage = React.lazy(() =>
  import("./App/views/cadastros/TributacaoPorNCM/TributacaoPorNCMForm"),
);
const TributacaoPorProdutoPage = React.lazy(() =>
  import("./App/views/cadastros/TributacaoPorProduto/TributacaoPorProdutoView"),
);
const ParametroNBSPage = React.lazy(() =>
  import("./App/views/cadastros/ParametroNBS/ParametroNBSView"),
);
const ParametroNBSFormPage = React.lazy(() =>
  import("./App/views/cadastros/ParametroNBS/ParametroNBSForm"),
);
const TributacaoPorNcmProdutoPage = React.lazy(() =>
  import("./App/views/cadastros/TributacaoPorProduto/TributacaoPorProdutoForm"),
);
const ClienteFornecedorPage = React.lazy(() =>
  import("./App/views/cadastros/ClienteFornecedor/ClienteFornecedorView"),
);
const ClienteFornecedorFormPage = React.lazy(() =>
  import("./App/views/cadastros/ClienteFornecedor/ClienteFornecedorForm"),
);
const PreferenciaFormPage = React.lazy(() =>
  import("./App/views/Parametrizacoes/Preferencias/PreferenciaForm"),
);
const ParametroFormPage = React.lazy(() =>
  import("./App/views/Parametrizacoes/Parametros/ParametroForm"),
);
const ParametrosNFSeFormPage = React.lazy(() =>
  import("./App/views/Parametrizacoes/ParametrosNFSe/ParametrosNFSeForm"),
);
const ParametrosNFSeListPage = React.lazy(() =>
  import("./App/views/Parametrizacoes/ParametrosNFSe/ParametrosNFSeListView"),
);
const MeuPerfilFormPage = React.lazy(() =>
  import("./App/views/MeuPerfil/MeuPerfilForm"),
);
const NFCePage = React.lazy(() => import("./App/views/NFCe/NFCeView"));
const NotaFiscalEntradaView = React.lazy(() =>
  import("./App/views/NotaFiscalEntrada/NotaFiscalEntradaView"),
);
const NotaFiscalEntradaForm = React.lazy(() =>
  import("./App/views/NotaFiscalEntrada/NotaFiscalEntradaForm"),
);
const AuxiliarVendaPage = React.lazy(() =>
  import("./App/views/GerenciarAuxiliar/AuxiliarVendaView"),
);
const NFePage = React.lazy(() => import("./App/views/GerenciarNFe/NFeView"));
const NFeFormPage = React.lazy(() => import("./App/views/NFe/NFeForm"));
const NfseFormPage = React.lazy(() => import("./App/views/NFse/NfseForm"));
const GerenciarNFSePage = React.lazy(() => import("./App/views/GerenciarNFSe/NFSeView"));
const PDVFormPage = React.lazy(() => import("./App/views/PDV/PDVForm"));
const FuncionarioPage = React.lazy(() =>
  import("./App/views/cadastros/Funcionario/FuncionarioView"),
);
const FuncionarioFormPage = React.lazy(() =>
  import("./App/views/cadastros/Funcionario/FuncionarioForm"),
);
const CertificadoDigitalPage = React.lazy(() =>
  import("./App/views/cadastros/CertificadoDigital/CertificadoDigitalView"),
);
const NFCeCargaView = React.lazy(() =>
  import("./App/views/NFCeCarga/NFCeCargaView"),
);
const TransportadoraPage = React.lazy(() =>
  import("./App/views/cadastros/Transportadoras/TransportadoraView"),
);
const TransportadoraFormPage = React.lazy(() =>
  import("./App/views/cadastros/Transportadoras/TransportadoraForm"),
);
const EspecieVolumePage = React.lazy(() =>
  import("./App/views/cadastros/EspecieVolume/EspecieVolumeView"),
);
const VeiculoPage = React.lazy(() =>
  import("./App/views/cadastros/Veiculo/VeiculoView"),
);
const ContadorPage = React.lazy(() =>
  import("./App/views/cadastros/Contador/ContadorView"),
);
const ContadorFormPage = React.lazy(() =>
  import("./App/views/cadastros/Contador/ContadorForm"),
);
const MaquinaCartaoPage = React.lazy(() =>
  import("./App/views/cadastros/MaquinaCartao/MaquinaCartaoView"),
);
const BalancaPage = React.lazy(() =>
  import("./App/views/cadastros/Balanca/BalancaView"),
);
const HomePage = React.lazy(() => import("./App/views/Home/Home"));
const PreferenciaEmailFormPage = React.lazy(() =>
  import("./App/views/Parametrizacoes/PreferenciasEmail/PreferenciasEmailForm"),
);
const ParametroBackupFormPage = React.lazy(() =>
  import("./App/views/Parametrizacoes/ParametroBackup/ParametroBackupForm"),
);
const PreferenciaImpressaoFormPage = React.lazy(() =>
  import(
    "./App/views/Parametrizacoes/ParametrosImpressao/ParametrosImpressaoForm"
  ),
);
const PapelPage = React.lazy(() =>
  import("./App/views/Parametrizacoes/Papeis/PapelView"),
);
const BackupDocumentosFiscaisPage = React.lazy(() =>
  import("./App/components/Modals/BackupDocumentosFiscaisModal.js"),
);
const HistoricoBackupPage = React.lazy(() =>
  import("./App/views/Backup/HistoricoBackupView.js"),
);
const RelatorioPage = React.lazy(() =>
  import("./App/views/Relatorios/RelatoriosView"),
);
const EtiquetasPage = React.lazy(() =>
  import("./App/views/Etiquetas/EtiquetasView.js"),
);
const EstoquePage = React.lazy(() => import("./App/views/Estoque"));
const CaixaPage = React.lazy(() => import("./App/views/Caixa"));
const FinanceiroPage = React.lazy(() => import("./App/views/Financeiro"));
const PlanoContasPage = React.lazy(() =>
  import("./App/views/cadastros/PlanoContas/PlanoContasView"),
);
const DREFullscreenPage = React.lazy(() =>
  import("./App/components/DRE/DREFullscreenView"),
);
const ContaBancariaPage = React.lazy(() =>
  import("./App/views/cadastros/ContaBancaria/ContaBancariaView"),
);
const ContaBancariaFormPage = React.lazy(() =>
  import("./App/views/cadastros/ContaBancaria/ContaBancariaForm"),
);
const BancoPage = React.lazy(() =>
  import("./App/views/cadastros/Banco/BancoView"),
);
const ServicoPage = React.lazy(() =>
  import("./App/views/cadastros/Servico/ServicoView"),
);
const SituacaoPage = React.lazy(() =>
  import("./App/views/cadastros/Situacao/SituacaoView"),
);
const SituacaoFormPage = React.lazy(() =>
  import("./App/views/cadastros/Situacao/SituacaoForm"),
);

const OrdemServicoFormPage = React.lazy(() =>
  import("./App/views/OrdemServico/OrdemServicoForm"),
);
const GerenciarOrdemServicoPage = React.lazy(() =>
  import("./App/views/GerenciarOrdemServico/OrdemServicoView"),
);
const AgendaPage = React.lazy(() => import("./App/views/Agenda/AgendaView"));
const AuxiliarServicoFormPage = React.lazy(() =>
  import("./App/views/AuxiliarServico/AuxiliarServicoForm"),
);
const GerenciarAuxiliarServicoPage = React.lazy(() =>
  import("./App/views/GerenciarAuxiliarServico/AuxiliarServicoView"),
);
const LogErroPage = React.lazy(() =>
  import("./App/views/Admin/LogErro/LogErroPage"),
);
const OrcamentoFormPage = React.lazy(() =>
  import("./App/views/Orcamento/OrcamentoForm"),
);
const GerenciarOrcamentoPage = React.lazy(() =>
  import("./App/views/GerenciarOrcamento/OrcamentoView"),
);
const FunilPropostasPage = React.lazy(() =>
  import("./App/views/GerenciarOrcamento/FunilPropostas"),
);
const DiagnosticoSefazPage = React.lazy(() =>
  import("./App/views/Admin/DiagnosticoSefaz/DiagnosticoSefazPage"),
);

const routes = [
  { path: "/home", exact: true, name: "Home", component: HomePage },

  {
    path: "/diagnostico-sefaz",
    exact: true,
    name: "Diagnostico SEFAZ",
    component: DiagnosticoSefazPage,
  },

  {
    path: "/cadastros/marcas",
    exact: true,
    name: "Marcas",
    component: MarcaPage,
  },
  {
    path: "/cadastros/equipamentos",
    exact: true,
    name: "Equipamentos",
    component: EquipamentoPage,
  },
  {
    path: "/cadastros/categorias",
    exact: true,
    name: "Categorias",
    component: CategoriaPage,
  },
  {
    path: "/cadastros/unidades_medida",
    exact: true,
    name: "Unidades de medida",
    component: UnidadeMedidaPage,
  },
  {
    path: "/cadastros/usuarios",
    exact: true,
    name: "Usuários",
    component: UsuarioPage,
  },
  {
    path: "/cadastros/empresas",
    exact: true,
    name: "Empresas",
    component: EmpresaPage,
  },
  {
    path: "/cadastros/produtos",
    exact: true,
    name: "Produtos",
    component: ProdutoPage,
  },
  {
    path: "/cadastros/produtos/duplicar/:codigo",
    exact: true,
    name: "Duplicar Produto",
    component: ProdutoFormPage,
  },
  {
    path: "/cadastros/produtos/:codigo",
    exact: false,
    name: "Produtos Form",
    component: ProdutoFormPage,
  },
  {
    path: "/cadastros/tabela_preco",
    exact: true,
    name: "Tabela de Preços",
    component: TabelaPreco,
  },
  {
    path: "/cadastros/tributacao_por_ncm",
    exact: true,
    name: "Tributação por NCM",
    component: TributacaoPorNcmPage,
  },
  {
    path: "/cadastros/tributacao_por_ncm/:codigo",
    exact: true,
    name: "Tributação por NCM Form",
    component: TributacaoPorNcmFormPage,
  },
  {
    path: "/cadastros/tributacao_por_produto",
    exact: true,
    name: "Tributação por Produto",
    component: TributacaoPorProdutoPage,
  },
  {
    path: "/cadastros/parametro_nbs",
    exact: true,
    name: "Parametros NBS",
    component: ParametroNBSPage,
  },
  {
    path: "/cadastros/parametro_nbs/:codigo",
    exact: true,
    name: "Cadastro Parametro NBS",
    component: ParametroNBSFormPage,
  },
  {
    path: "/cadastros/tributacao_por_produto/:codigo",
    exact: true,
    name: "Tributação por Produto Form",
    component: TributacaoPorNcmProdutoPage,
  },
  {
    path: "/cadastros/clientes",
    exact: true,
    name: "Clientes",
    component: ClienteFornecedorPage,
  },
  {
    path: "/cadastros/clientes/:codigo",
    exact: false,
    name: "Clientes Form",
    component: ClienteFornecedorFormPage,
  },
  {
    path: "/cadastros/funcionarios",
    exact: true,
    name: "Funcionários ",
    component: FuncionarioPage,
  },
  {
    path: "/cadastros/funcionarios/:codigo",
    exact: false,
    name: "Funcionario Form",
    component: FuncionarioFormPage,
  },
  {
    path: "/cadastros/certificados",
    exact: true,
    name: "Certificado Digital ",
    component: CertificadoDigitalPage,
  },
  {
    path: "/cadastros/transportadoras",
    exact: true,
    name: "Transportadoras ",
    component: TransportadoraPage,
  },
  {
    path: "/cadastros/transportadoras/:codigo",
    exact: false,
    name: "Transportadoras Form",
    component: TransportadoraFormPage,
  },
  {
    path: "/cadastros/unidades_volume",
    exact: true,
    name: "Unidades de Volume",
    component: EspecieVolumePage,
  },
  {
    path: "/cadastros/veiculos",
    exact: true,
    name: "Veículos",
    component: VeiculoPage,
  },
  {
    path: "/cadastros/contadores",
    exact: true,
    name: "Contador",
    component: ContadorPage,
  },
  {
    path: "/cadastros/contadores/:codigo",
    exact: false,
    name: "Contador Form",
    component: ContadorFormPage,
  },
  {
    path: "/cadastros/maquinas-cartao",
    exact: true,
    name: "Máquinas de Cartão",
    component: MaquinaCartaoPage,
  },
  {
    path: "/cadastros/balancas",
    exact: true,
    name: "Balanças",
    component: BalancaPage,
  },
  {
    path: "/cadastros/plano-contas",
    exact: true,
    name: "Plano de Contas",
    component: PlanoContasPage,
  },
  {
    path: "/cadastros/contas",
    exact: true,
    name: "Contas Bancárias",
    component: ContaBancariaPage,
  },
  {
    path: "/cadastros/contas/:codigo",
    exact: false,
    name: "Conta Bancária Form",
    component: ContaBancariaFormPage,
  },
  {
    path: "/cadastros/bancos",
    exact: true,
    name: "Bancos",
    component: BancoPage,
  },
  {
    path: "/cadastros/servicos",
    exact: true,
    name: "Serviços",
    component: ServicoPage,
  },
  {
    path: "/cadastros/situacoes",
    exact: true,
    name: "Situações",
    component: SituacaoPage,
  },
  {
    path: "/cadastros/situacoes/:codigo",
    exact: false,
    name: "Situação Form",
    component: SituacaoFormPage,
  },

  {
    path: "/preferencias",
    exact: true,
    name: "Preferencias Form",
    component: PreferenciaFormPage,
  },
  {
    path: "/parametros_email",
    exact: true,
    name: "Preferencias Email Form",
    component: PreferenciaEmailFormPage,
  },
  {
    path: "/parametros_backup",
    exact: true,
    name: "Paramêtros de backup",
    component: ParametroBackupFormPage,
  },
  {
    path: "/parametros",
    exact: true,
    name: "Parâmetros Form",
    component: ParametroFormPage,
  },
  {
    path: "/parametros_nfse",
    exact: true,
    name: "Parâmetros de Impostos NFS-E",
    component: ParametrosNFSeListPage,
  },
  {
    path: "/parametros_nfse/:id",
    exact: true,
    name: "Cadastro Parâmetros de Impostos NFS-E",
    component: ParametrosNFSeFormPage,
  },
  {
    path: "/parametros_impressao",
    exact: true,
    name: "Preferencias Impressão Form",
    component: PreferenciaImpressaoFormPage,
  },
  { path: "/papeis", exact: true, name: "Papéis", component: PapelPage },
  {
    path: "/meu_perfil",
    exact: true,
    name: "Meu perfil Form",
    component: MeuPerfilFormPage,
  },

  {
    path: "/auxiliar-venda",
    exact: true,
    name: "Gerenciar Auxiliar de Venda",
    component: AuxiliarVendaPage,
  },
  { path: "/nfce", exact: true, name: "Gerenciar NFCe", component: NFCePage },
  { path: "/pdv/:codigo", exact: true, name: "NFCe", component: PDVFormPage },
  { path: "/nfe", exact: true, name: "Gerenciar NFe", component: NFePage },
  { path: "/nfe/:codigo", exact: true, name: "NFe", component: NFeFormPage },
  { path: "/nfse", exact: true, name: "Gerenciar NFS-e", component: GerenciarNFSePage },
  { path: "/nfse/:codigo", exact: true, name: "NFS-e", component: NfseFormPage },
  {
    path: "/carga",
    exact: true,
    name: "NFCe Teste Carga",
    component: NFCeCargaView,
  },
  {
    path: "/nota_entrada",
    exact: true,
    name: "Gerenciar Notas Fiscais de Entrada",
    component: NotaFiscalEntradaView,
  },
  {
    path: "/nota_entrada/:codigo",
    exact: true,
    name: "Nota Fiscal de Entrada",
    component: NotaFiscalEntradaForm,
  },
  {
    path: "/backup_documentos_fiscais",
    exact: true,
    name: "Backup Documentos Fiscais",
    component: BackupDocumentosFiscaisPage,
  },
  {
    path: "/historico_backups",
    exact: true,
    name: "Histórico de Backup Documentos Fiscais",
    component: HistoricoBackupPage,
  },

  { path: "/estoque", exact: false, name: "Estoque", component: EstoquePage },
  { path: "/caixa", exact: false, name: "Caixa", component: CaixaPage },
  {
    path: "/financeiro",
    exact: false,
    name: "Financeiro",
    component: FinanceiroPage,
  },

  {
    path: "/relatorios",
    exact: true,
    name: "Relatórios",
    component: RelatorioPage,
  },
  {
    path: "/relatorio-dre-fullscreen",
    exact: true,
    name: "DRE Fullscreen",
    component: DREFullscreenPage,
  },
  {
    path: "/relatorios",
    exact: true,
    name: "Relatórios",
    component: RelatorioPage,
  },

  {
    path: "/etiquetas",
    exact: true,
    name: "Etiquetas",
    component: EtiquetasPage,
  },
  {
    path: "/servicos/ordem-servico",
    exact: true,
    name: "Gerenciar Ordens de Serviço",
    component: GerenciarOrdemServicoPage,
  },
  {
    path: "/servicos/agenda",
    exact: true,
    name: "Agenda",
    component: AgendaPage,
  },
  {
    path: "/servicos/ordem-servico/:codigo",
    exact: true,
    name: "Ordem de Serviço",
    component: OrdemServicoFormPage,
  },
  {
    path: "/servicos/auxiliar-servico",
    exact: true,
    name: "Gerenciar Auxiliar de Serviço",
    component: GerenciarAuxiliarServicoPage,
  },
  {
    path: "/servicos/auxiliar-servico/:codigo",
    exact: false,
    name: "Auxiliar de Serviço",
    component: AuxiliarServicoFormPage,
  },
  {
    path: "/vendas/orcamento",
    exact: true,
    name: "Gerenciar Orçamentos",
    component: GerenciarOrcamentoPage,
  },
  {
    // Antes da rota :codigo para não ser capturado como parâmetro do orçamento.
    path: "/vendas/orcamento/funil-propostas",
    exact: true,
    name: "Funil de Propostas",
    component: FunilPropostasPage,
  },
  {
    path: "/vendas/orcamento/:codigo",
    exact: true,
    name: "Orçamento",
    component: OrcamentoFormPage,
  },
  {
    path: "/visualizar-log",
    exact: true,
    name: "Visualizar Log",
    component: LogErroPage,
  },
];

export default routes;
